// ============================================================
// KF CONSUMER — ProductViewer (detalle de producto)
// ============================================================
// Consumidor del VCE bajo el CONTRATO: describe ÚNICAMENTE
//   • Qué contenido posee (media[] / images[] legacy)
//   • En qué contexto se encuentra ('detail')
//   • Qué configuración de tenant utiliza (kfDetailConfig)
// El motor (SmartMediaComposer) DECIDE — R4 (video+detail →
// poster+controls) y R7 (detail → gallery+counter) por regla — y
// ejecuta la decisión sobre SmartMedia. Cero lógica visual aquí.
// F3: la decisión del motor gobierna el render del detalle.
// ============================================================
import React from 'react';
import { SmartMediaComposer } from '../Common/visual-engine';
import { kfDetailConfig } from './visualEngine.config';

interface ProductViewerProduct {
  code: string;
  name?: string;
  media?: Array<{ type?: 'image' | 'video'; url: string; poster?: string }>;
  images?: string[];
}

interface ProductViewerProps {
  product: ProductViewerProduct;
}

export const ProductViewer: React.FC<ProductViewerProps> = ({ product }) => {
  return (
    <SmartMediaComposer
      media={product.media}
      images={product.images}
      blocked={false}
      alt={product.name || ''}
      context="detail"
      config={kfDetailConfig}
      videoPoster={product.images?.[0]}
    />
  );
};

export default ProductViewer;
